<template>
  <v-card class="ma-0" flat><!-- v-click-outside="unfocusEntireCard" -->
    <slotted-card :editable="true" :title="$t('servicesystem.common_objects.machine.machine_details')"
      :icon="'mdi-information'" :fontsize="'h4'" :headerclass="'pl-3'" :headertextclass="'nowrapheader'"
      :externalEditTrigger="editmodetrigger" @editMode="setEditMode" @valid="setValid">

      <!--
      <template v-slot:headerbtns>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="jobsdialogtrigger++"
                   v-bind="attrs"
                   v-on="on"
                   icon
                   color="primary"
                   class="mx-2">
              <v-icon v-text="'mdi-briefcase-search'" />
            </v-btn>
          </template>
<span v-text="$t('servicesystem.common_objects.customer.other_jobs')" />
</v-tooltip>
</template>
-->

      <template v-slot:content>
        <v-row no-gutters>
          <v-col :cols="0" class="mx-3">
            <v-row class="mt-0">
              <v-col>
                <QTextField v-model="editObject.Name" :label="$t('servicesystem.common_objects.machine.location')"
                  :externaledit="editMode" :rules="[requiredRule]" maxlength="50"
                  @FocusState="editMode ? null : editmodetrigger++">
                </QTextField>
              </v-col>
              <v-col>
                <QTextField v-model="editObject.SerialNumber"
                  :label="$t('servicesystem.common_objects.machine.serial_number')" :externaledit="editMode"
                  :clearable="!serialNumberRequired" @FocusState="editMode ? null : editmodetrigger++">
                </QTextField>
              </v-col>
              <v-col>
                <QTextField v-model="editObject.Qrcode" :label="$t('servicesystem.common_objects.machine.qr_code')"
                  :externaledit="editMode" @FocusState="editMode ? null : editmodetrigger++">
                </QTextField>
              </v-col>
            </v-row>
            <v-row class="mt-n4">
              <v-col>
                <date-li :label="$t('servicesystem.common_objects.machine.purchase_date')"
                  :value="editObject.BoughtDate" :keyname="'BoughtDate'" :edit="true" class="mx-n2" @fetch="updateValue"
                  @FocusState="editMode ? null : editmodetrigger++">
                </date-li>
              </v-col>
              <v-col>
                <date-li :label="$t('servicesystem.common_objects.machine.installation_date')"
                  :value="editObject.InstallationDate" :keyname="'InstallationDate'" :edit="true" class="mx-n2"
                  @fetch="updateValue" @FocusState="editMode ? null : editmodetrigger++">
                </date-li>
              </v-col>
              <v-col>
                <date-li :label="$t('servicesystem.common_objects.machine.warranty_expires')"
                  :value="editObject.WarrantyExpiresDate" :keyname="'WarrantyExpiresDate'" :edit="true" class="mx-n2"
                  @fetch="updateValue" @FocusState="editMode ? null : editmodetrigger++">
                </date-li>
              </v-col>
            </v-row>
            <!--
            <v-row>
              <v-col>
                <v-text-field type="date"  :label="$t('servicesystem.common_objects.machine.purchase_date')" v-model="editObject.BoughtDate" dense hide-details></v-text-field>
              </v-col>
              <v-col>
                <v-text-field type="date"  :label="$t('servicesystem.common_objects.machine.installation_date')" v-model="editObject.InstallationDate" dense hide-details></v-text-field>
              </v-col>
              <v-col>
                <v-text-field type="date"  :label="$t('servicesystem.common_objects.machine.warranty_expires')" v-model="editObject.WarrantyExpiresDate" dense hide-details></v-text-field>
              </v-col>
            </v-row>
          -->
            <v-row>
              <v-col>
                <QTextField v-model="editObject.Facility" :label="$t('servicesystem.common_objects.machine.facility')"
                  :externaledit="editMode" @FocusState="editMode ? null : editmodetrigger++">
                </QTextField>
              </v-col>
              <v-col>
                <QTextField v-model="editObject.YearlyBudget"
                  :label="$t('servicesystem.common_objects.machine.yearly_budget')" :externaledit="editMode"
                  @FocusState="editMode ? null : editmodetrigger++">
                </QTextField>
              </v-col>
              <v-col>
                <QCheckboxInput v-model="editObject.IsActive" :label="$t('servicesystem.common_objects.machine.active')"
                  :externaledit="editMode" @FocusState="editMode ? null : editmodetrigger++">
                </QCheckboxInput>
              </v-col>
            </v-row>
            <v-row class="mb-0 mt-2">
              <v-col style="background-color: rgb(243 247 255);" class="pt-2">
                <QTextArea v-model="editObject.Note" :label="$t('servicesystem.common_objects.machine.note')"
                  :externaledit="editMode" :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampMachineNote"
                  @FocusState="editMode ? null : editmodetrigger++">
                </QTextArea>
              </v-col>
            </v-row>

            <edit-bar :externalTrigger="editMode" :saveable="valid && IsChanged"
              :saveText="$t('servicesystem.common_objects.commonterms.save')" :dividerPos="'none'"
              :class="editMode ? 'mt-1' : null" @saveEmit="save()" @modeEmit="editmodetrigger++">
            </edit-bar>
          </v-col>
        </v-row>
      </template>
    </slotted-card>
  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DateLi from "@/components/Inputs/DateListItem.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "EditableMachineDetails",
  props: {
    machine: Object,
    subjob: Object,
  },
  components: {
    EditBar,
    SlottedCard,
    DateLi,
  },
  mixins: [clientAPI],

  data() {
    return {
      editMode: false,
      editmodetrigger: 0,
      valid: false,
      editObject: {},
    };
  },

  mounted() {
    this.setEditObject();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.MachineChange,
      this.notifyChanges
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.MachineChange,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      if (args.Id == this.machine.Id) {
        console.log("machine was updated externally");
      }
    },

    updateValue(update) {
      this.editObject[update.key] = update.value;
    },

    save() {
      this.loading = true;
      const dto = Object.assign(this.editObject);

      this.changeMachine(dto)
        .then((response) => {
          this.editmodetrigger++;
          this.$emit("Update", response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    setEditObject() {
      this.editObject = Object.assign({}, this.machine);
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.editmodetrigger++;
      }
    },
  },

  computed: {
    IsChanged() {
      if (this.editObject && this.machine) {
        return !this.SameValue(this.editObject, this.machine);
      } else {
        return false;
      }
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    serialNumberRequired() {
      return this.$store.state.GlobalSettings.SerialNumberRequired;
    },
  },

  watch: {
    machine: {
      handler() {
        //console.log("machine change");
        this.setEditObject();
      },
      deep: true,
    },

    editMode: function (val) {
      if (val) {
        this.setEditObject();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>